import React from 'react';
import { FORM_KINDS, FORM_KIND_LABELS } from '../../types/formSchema';

interface Props {
  selected: string;
  onChange: (kind: string) => void;
}

export default function FormKindPicker({ selected, onChange }: Props) {
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>Form Types</div>
      {FORM_KINDS.map((kind) => (
        <button
          key={kind}
          onClick={() => onChange(kind)}
          style={{
            ...itemStyle,
            background: selected === kind ? '#dbeafe' : 'transparent',
            color: selected === kind ? '#1d4ed8' : '#374151',
            fontWeight: selected === kind ? 600 : 400,
            borderLeft: selected === kind ? '3px solid #3b82f6' : '3px solid transparent',
          }}
        >
          {FORM_KIND_LABELS[kind]}
        </button>
      ))}
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid #e5e7eb',
  minWidth: 180,
  background: '#fff',
};

const headerStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: '#6b7280',
  padding: '16px 16px 8px',
};

const itemStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: '10px 16px',
  border: 'none',
  cursor: 'pointer',
  fontSize: 13,
  transition: 'background 0.1s',
};
